/// <reference path='../_all.ts' />

module part {
  'use strict';
  
  export class PartDocument {
    constructor(
      public FileSrcRevId: number,
      public RevDestName: string,
      public TypeNameId: number,
      public TypeNameD: string,
      public TypeNameE: string,
      public TitleD: string,
      public TitleE: string,
      public Id: number,
      public LanguageCode: number[],
      public DocumentId: number,
      public RevDestSize?: number,
    ) { }
  }
}